<template>
  <div class=  "grid-container">
  <!--
  <div class="grid" :style="gridStyle">
    <div
      v-for="index in totalSquares"
      :key="index"
      class="grid-square"
      :style="squareStyle"
    ></div>
  </div>-->
    <div class = "block-holder-container">
      <div class = "block-holder" v-for="(event,index) in eventData"
        :key="index"
        :style = "{height:(event.blocks.length*squareSize)+'px',width:(4*squareSize)+'px'}"
        :id = "'block-holder-'+index"
      >

      </div>
      <div class = "block-holder" 
        :style = "{height:'100vh',width:(4*squareSize)+'px'}"
        :id = "'block-holder-'+eventData.length"
      ></div>
    </div>
  
  </div>
</template>

<script>
export default {
  name: "Grid",
  props: {
    squareSize: {
      type: Number,
      required: true,
    },
    eventData:{
      type:Array,
      required:true
    }
  },
  data(){
    return{
        currHolderIndex:0,
    }
  },
  mounted(){
    //console.log("updated-grid-location")
    //let blockHolderRect = document.getElementById('block-holder-'+this.currHolderIndex).getBoundingClientRect()
    this.$emit('updated-grid-location', this.getGridHolderRects() )
    window.addEventListener('resize',()=>{
      this.handleResize()
      setTimeout(()=>{
        this.handleResize()
      }, 2500
    )
    })
  },
  updated(){
    //console.log("updated-grid-location")
    //let blockHolderRect = document.getElementById('block-holder-'+this.currHolderIndex).getBoundingClientRect()
    console.log("updated grid")
    this.$emit('updated-grid-location', this.getGridHolderRects() )
  },
  computed: {
    // Calculate the grid's overall size based on square size and the number of squares
    gridStyle() {
      return {
        display: "grid",
        gridTemplateColumns: `repeat(4, ${this.squareSize}px)`,
        gridTemplateRows: `repeat(32, ${this.squareSize}px)`,
        gap: "0px", // No gap between squares
      };
    },
    squareStyle() {
      return {
        width: `${this.squareSize}px`,
        height: `${this.squareSize}px`,
        border: "1px solid #ccc", // Just a light border for visual clarity
        boxSizing: "border-box",
      };
    },
    totalSquares() {
      //let height= 0;
      //for (let event in this.eventData){
      //  height+=event.blocks.length;
      //}
      return 4 * 32; // 4 columns x 32 rows
    },
  },
  methods:{
      getGridHolderRects(){
        let gridHolderRects = [];
        for(let i=0;i<this.eventData.length;i++){
          gridHolderRects.push(document.getElementById('block-holder-'+i).getBoundingClientRect())
        }
        return gridHolderRects
      },
      handleResize(){
        this.$emit('updated-grid-location', this.getGridHolderRects() )
      }
  }
};
</script>

<style scoped>
.grid {
  position: absolute;


}
.grid-square {
  background-color: #f4f4f4;
}

.grid-container {
  position:static;
  margin:auto;
  transform: translateY(00px);
  transition: transform 1s ease;
}

.block-holder-container{
  display: flex;
  flex-flow: column-reverse nowrap;
  overflow-y:hidden;
  position: relative;
}

.block-holder{

  opacity:0.2;
  width: 240px
}
</style>
